{
  "validation": {
    "required": "Este campo es obligatorio",
    "email": "Introduce una dirección de correo válida",
    "minLength": "Debe tener al menos {{min}} caracteres",
    "maxLength": "Debe tener como máximo {{max}} caracteres",
    "passwordMatch": "Las contraseñas no coinciden"
  },
  "pagination": {
    "previous": "Anterior",
    "next": "Siguiente",
    "page": "Página {{current}} de {{total}}",
    "showing": "Mostrando {{from}} a {{to}} de {{total}} resultados"
  },
  "table": {
    "noResults": "No se encontraron resultados",
    "loading": "Cargando datos...",
    "sortAsc": "Ordenar de forma ascendente",
    "sortDesc": "Ordenar de forma descendente"
  }
}
